import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import CloudinaryUpload from "../components/CloudinaryUpload";
import { Plus, Trash2 } from "lucide-react";

const CATS = ["food", "laundry", "wifi", "cleaning", "security", "maintenance", "tiffin", "stationery", "other"];

export default function VendorRegister() {
  const { refresh } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({
    name: "", business_name: "", email: "", phone: "", password: "Vendor@2025",
    category: "food", city: "", pincode: "", description: "", gst_number: "",
  });
  const [services, setServices] = useState([{ name: "", price: "", unit: "month" }]);
  const [images, setImages] = useState([]);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const svc = services.filter(s => s.name && s.price).map(s => ({ ...s, price: parseFloat(s.price) }));
      await api.post("/vendors/register", { ...f, services: svc, images });
      toast.success("Vendor account created!");
      refresh();
      nav("/vendors/dashboard");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="paper min-h-[80vh]" data-testid="vendor-register-page">
      <div className="max-w-3xl mx-auto px-5 md:px-10 py-10">
        <div className="brut-card p-8">
          <span className="brut-tag lime">Vendor onboarding</span>
          <h1 className="font-display font-black text-3xl mt-3">List your service on Hostro.</h1>
          <p className="text-[#484848] mt-2">Reach 1000s of PG owners. No setup fee. Free listing.</p>

          <form onSubmit={submit} className="mt-6 space-y-4">
            <div className="grid sm:grid-cols-2 gap-3">
              <div><label className="label-eyebrow">Your name</label><input required className="brut-input mt-1" value={f.name} onChange={(e)=>setF({...f, name: e.target.value})} data-testid="v-name"/></div>
              <div><label className="label-eyebrow">Business name</label><input required className="brut-input mt-1" value={f.business_name} onChange={(e)=>setF({...f, business_name: e.target.value})} data-testid="v-business"/></div>
              <div><label className="label-eyebrow">Email</label><input required type="email" className="brut-input mt-1" value={f.email} onChange={(e)=>setF({...f, email: e.target.value})} data-testid="v-email"/></div>
              <div><label className="label-eyebrow">Phone</label><input required className="brut-input mt-1" value={f.phone} onChange={(e)=>setF({...f, phone: e.target.value})} data-testid="v-phone"/></div>
              <div><label className="label-eyebrow">Password</label><input required minLength={6} className="brut-input mt-1" value={f.password} onChange={(e)=>setF({...f, password: e.target.value})} data-testid="v-password"/></div>
              <div><label className="label-eyebrow">Category</label>
                <select className="brut-input mt-1" value={f.category} onChange={(e)=>setF({...f, category: e.target.value})} data-testid="v-category">
                  {CATS.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>
              <div><label className="label-eyebrow">City</label><input required className="brut-input mt-1" value={f.city} onChange={(e)=>setF({...f, city: e.target.value})} data-testid="v-city"/></div>
              <div><label className="label-eyebrow">Pincode</label><input className="brut-input mt-1" value={f.pincode} onChange={(e)=>setF({...f, pincode: e.target.value})}/></div>
              <div className="sm:col-span-2"><label className="label-eyebrow">GST (optional)</label><input className="brut-input mt-1" value={f.gst_number} onChange={(e)=>setF({...f, gst_number: e.target.value})}/></div>
            </div>

            <div>
              <label className="label-eyebrow">Description</label>
              <textarea className="brut-input mt-1 min-h-[80px]" value={f.description} onChange={(e)=>setF({...f, description: e.target.value})} placeholder="Tell PG owners what makes you stand out…" data-testid="v-desc"/>
            </div>

            <div>
              <label className="label-eyebrow">Services & pricing</label>
              <div className="space-y-2 mt-1">
                {services.map((s, i) => (
                  <div key={i} className="flex gap-2 items-center">
                    <input className="brut-input flex-1" placeholder="Service name" value={s.name} onChange={(e)=>{const x=[...services]; x[i].name=e.target.value; setServices(x);}}/>
                    <input className="brut-input w-28" type="number" placeholder="Price ₹" value={s.price} onChange={(e)=>{const x=[...services]; x[i].price=e.target.value; setServices(x);}}/>
                    <input className="brut-input w-24" placeholder="unit" value={s.unit} onChange={(e)=>{const x=[...services]; x[i].unit=e.target.value; setServices(x);}}/>
                    <button type="button" className="brut-btn pink !p-2" onClick={()=>setServices(services.filter((_, ix) => ix !== i))}><Trash2 size={14}/></button>
                  </div>
                ))}
                <button type="button" className="brut-btn white !text-xs" onClick={()=>setServices([...services, { name: "", price: "", unit: "month" }])}><Plus size={12}/> Add service</button>
              </div>
            </div>

            <div>
              <label className="label-eyebrow">Showcase images</label>
              <CloudinaryUpload folder="hostro/blog" multiple={true} value={images} onChange={setImages} testId="vendor-images"/>
            </div>

            <button type="submit" className="brut-btn w-full" disabled={busy} data-testid="v-submit">{busy ? "Creating…" : "Create vendor account"}</button>
          </form>
        </div>
      </div>
    </div>
  );
}
